import { useEffect } from "react";
import Prismic from "prismic-javascript";
import { Client } from "../../prismic1";
import SliceZone from "next-slicezone";
import { useGetStaticProps } from "next-slicezone/hooks";
import { fetchAdditionalData } from "../../utils/fetch-additional-data";
import { AdditionalDataProvider } from "../../utils/additional-data-context";
import { useLayout } from "../../utils/layout-context";
import resolver from "../../sm-resolver.js";
import RelatedStories from "../../components/RecentRelatedStories";
import HeroBackgroundImage from "../../components/HeroBackgroundImage";
import { getLanguage, getExtensionLanguage } from "../../lib/getLanguage";
import Head from "../../components/Head";
import errorService from '../../services/error/error-service'

const Project = (props) => {

  const { data, currentProject,uid } = props;
  const { setHeaderColor } = useLayout();
  useEffect(() => {
    if (data) setHeaderColor(false);
  }, [data]);

  return (
    <>
      <Head data={data} canonical={`/project/${uid}`} />
      <AdditionalDataProvider value={props.additionalData}>
        <HeroBackgroundImage primary={currentProject}></HeroBackgroundImage>
        <SliceZone {...props} resolver={resolver} />
        <RelatedStories
          allBlogsBasedOnProjectCategory={props.allBlogsBasedOnProjectCategory}
        ></RelatedStories>
      </AdditionalDataProvider>
    </>
  );
};

export async function getStaticProps({
  preview = null,
  previewData = {},
  params,
  locale,
}) {
  const client = Client();
  const languageObject = getLanguage(locale);
  const language = await languageObject.prismicLanguage.toLowerCase();
  const sliceMachine = useGetStaticProps({
    client,
    params: {
      fetchLinks: [
        "project_category.icon",
        "project_category.title",
        "project_category.uid",
        "project.featured_image",
        "project.title",
        "project.project_category",
        "blog_post.title",
        "blog_post.featured_image",
        "blog_post.date",
      ],
      lang: language,
    },
    type: "project",
    uid: ({ params }) => params.uid,
  });

  const { props } = await sliceMachine({ preview, previewData, params });
  const additionalData = await fetchAdditionalData(
    props.slices,
    params.uid,
    language
  );
  const currentProject = await client.getByUID("project", params.uid, {
    lang: language,
    fetchLinks: ["project_category.title"],
  });

  if (!currentProject){
    return errorService.notFoundResponse
  }
  
  const all_blogs = await client.query(
    Prismic.Predicates.at("document.type", "blog_post"),
    {
      lang: language,
      ref: null,
      fetchLinks: ["project_category.title", "blog_topic.topic_name"],
      pageSize: 100,
      orderings: "[my.blog_post.date desc]",
    }
  );
  const allBlogsBasedOnProjectCategory =
    all_blogs.results.filter((blog, i) => {
      return blog.data.project_categories.find((project_category, idx) => {
        return (
          project_category.project_category.uid ==
          currentProject.data.project_category.uid
        );
      });
    }) || null;
  return {
    props: {
      ...props,
      additionalData,
      allBlogsBasedOnProjectCategory,
      currentProject,
    },
  };
}

export async function getStaticPaths() {
  const client = Client();
  const allProjects = await client.query(
    Prismic.Predicates.at("document.type", "project"),
    { lang: "*", pageSize: 100 }
  );
  const paths = allProjects.results.map((node) => {
    const languageObject = getExtensionLanguage(node.lang);
    const language = languageObject.prismicLanguage.toLowerCase();
    return {
      params: {
        uid: node.uid,
      },
      locale: language,
    };
  });
  return {
    paths,
    fallback: 'blocking',
  };
}

export default Project;
